export const tagsEnum = {
  ALL: 'All',
  REACT_NATIVE: 'React Native',
  REACT_JS: 'React JS',
  NEXT_JS: 'Next JS',
  BACKEND_PROJECTS: 'Backend Projects',
  GAME_APPS: 'Game Apps',
  AR_PROJECT: 'AR Project',
};
export const tags = [
  tagsEnum.ALL,
  tagsEnum.REACT_NATIVE,
  tagsEnum.REACT_JS,
  tagsEnum.NEXT_JS,
  tagsEnum.GAME_APPS,
  tagsEnum.BACKEND_PROJECTS,
  tagsEnum.AR_PROJECT,
];
